module.exports = __webpack_public_path__ + "fonts/IndivisibleWebRegular.78612061.eot";